import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterUnit = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterUnit'),
);
